/* istanbul ignore file */
import React from 'react';
import type { GetServerSideProps, InferGetServerSidePropsType } from 'next';

import { RibbonsPage } from 'src/components/templates/RibbonsPage/RibbonsPage';
import { SKIP_CONTENT_TARGET_ID } from 'src/constants/elementIds';
import { getPageContent } from 'src/content/getPageContent';
import type { ContentPageProps, PageConfiguration } from 'src/types/PageProps';
import { getPageMetadata } from 'src/utils/getPageMetadata';

const pageConfigDX: PageConfiguration = {
  env: process.env.NODE_ENV,
  pageType: 'campaign',
  trackingCategory: 'Campaign',
  contentType: 'campaign_tc',
};

const pageConfigRibbons: PageConfiguration = {
  env: process.env.NODE_ENV,
  pageType: 'campaign',
  trackingCategory: 'Campaign',
  contentType: 'campaign',
};

export const getServerSideProps: GetServerSideProps<ContentPageProps> = async (context) => {
  const pageMetadata = getPageMetadata(context);
  // TODO: remove feature switch
  const isDXStack = true;
  const pageConfig = isDXStack ? pageConfigDX : pageConfigRibbons;

  try {
    const pageContent = await getPageContent(pageConfig, pageMetadata);
    return {
      props: {
        pageConfig,
        pageMetadata,
        pageContent: pageContent.pageContent,
        pageEventCategory: pageConfig.trackingCategory,
        navData: pageContent.navData,
        topBannerData: pageContent.topBannerData,
      },
    };
  } catch {
    return {
      notFound: true,
    };
  }
};

const CampaignPage = (props: InferGetServerSidePropsType<typeof getServerSideProps>) => (
  <div id={SKIP_CONTENT_TARGET_ID}>
    <RibbonsPage {...props} />
  </div>
);

export default CampaignPage;
